import { ICommand } from './';

export const divider: ICommand = {
  keyCommand: 'divider',
};
